import type { Assembler } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'
import { SHORTCUT_EMPLOYEE_FIELDS } from '@@partner:graphql/shortcuts'

export interface AssemblerInfoInput {
  id?: GQL_ID
  first_name: string
  last_name: string
  status: number
  phone: string
  shop_id?: GQL_ID
  role?: string
}

export interface SaveAssembler {
  assembler: Assembler
}

export interface SaveAssemblerVariables {
  assemblerInfo: AssemblerInfoInput
  upsert: boolean
}

export const GQL_MUTATION_SAVE_ASSEMBLER = gql`
  mutation($assemblerInfo: AssemblerInfoInput, $upsert: Boolean) {
    assembler: updateAssembler(newData: $assemblerInfo, upsert: $upsert) {
      ${SHORTCUT_EMPLOYEE_FIELDS}
    }
  }
`

export const useMutateSaveAssembler = () => {
  return useMutation<SaveAssembler, SaveAssemblerVariables>(
    GQL_MUTATION_SAVE_ASSEMBLER
  )
}
